import { query, getBranding } from "@sinao/core-js";
import i18n from "@/i18n";

const guest = {
	state: () => ({
		siren: null,
		name: null,
		legalForm: null,
		closeAccountingPeriod: null,
		vatRegime: null,
		address: null,
		phone: null
	}),
	mutations: {
		siren(state, payload) {
			state.siren = payload;
		},
		name(state, payload) {
			state.name = payload;
		},
		legalForm(state, payload) {
			state.legalForm = payload;
		},
		closeAccountingPeriod(state, payload) {
			state.closeAccountingPeriod = payload;
		},
		vatRegime(state, payload) {
			state.vatRegime = payload;
		},
		address(state, payload) {
			state.address = payload;
		},
		phone(state, payload) {
			state.phone = payload;
		}
	},
	actions: {
		async branding(_, { hostname_alias }) {
			const brand = await getBranding(hostname_alias);
			i18n.softwareName = brand?.name || "Sinao";

			return brand;
		},
		async register(_, { firstname, lastname, email, password, cgu }) {
			return await query({
				operationId: "account.create",
				data: {
					firstname,
					lastname,
					email,
					password,
					cgu
				}
			});
		},
		async login(_, { email, password }) {
			return await query({
				operationId: "auth.login",
				data: {
					email,
					password
				}
			});
		},
		async createApp(_, { appName, token, domain }) {
			return await query({
				operationId: "app.create",
				token,
				params: {
					organization_name: appName,
					hostname_alias: domain,
					"expand[0]": "subscription"
				}
			});
		},
		async updateOrganization({ state }, { token, appId }) {
			try {
				const {
					siren,
					name,
					legalForm,
					closeAccountingPeriod,
					address,
					phone
				} = state;

				await query({
					operationId: "app.organization.update",
					token,
					params: { appId, "expand[]": "establishments" },
					data: {
						national_id: siren,
						name,
						billing_name: name,
						vat_id: "",
						legalForm: null,
						legal_form: legalForm,
						closeaccounting_period: closeAccountingPeriod,
						vatRegime: null,
						formatted_address: address,
						phone,
						establishments: [
							{
								formatted_address: address,
								phone
							}
						]
					}
				});
			} catch (error) {
				console.error(error);
			}
		}
	}
};

export default guest;
